




import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {},
})
export default class RedirectFromMobile extends Vue {
  public async created() {
    window.open(
      "https://labelcall.com/contact/",
      "_blank" 
    );
    history.back();
  }
}
